











import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DialogLoading extends Vue {

    @Prop(Boolean) show!: boolean
    @Prop(String) title!: string
}
